export default __webpack_public_path__ + "static/media/br.cf502646.svg";